import React from 'react'
import './solution.scss'

import VO_QUESTION_MARK from '../../../../assets/VO_QUESTION_MARK.svg'

const solution = () => {
  return (
    <div className="solution">
      <div className="mission__wrapper">
        <h2 className="primary__heading">Customized Communications Solutions</h2>
        <p>
          Virtual Enterprise Group LLC telecommunication systems are outfitted with the Cisco AVVID architecture, this ensures that our operations are highly available and easily scalable. 
          High availability is essential to both customer satisfaction and employee productivity. 
          By ensuring that our technical team is certified in Cisco, Microsoft & Mikrotik Technologies we are proactive in resolving technical issues before a major downtime is experienced.
        </p>
        <h2 className="primary__heading">Quality of Service</h2>
        <p>
          We only hire telephone agents who are dedicated to our own aims – to provide you with the kind of service you would want your own staff to provide. 
          Your callers will never hear extraneous background sounds, such as a radio playing music, children crying, or a dog barking. 
          Callers directed to call centers that use remote telephone agents often have to put up with that kind of poor quality. 
          You should always demand the best. After all, if you are paying for a quality service, make sure you get it. 
          The only way to be sure of getting the best service you can, is to seek a service with professionally trained and dedicated staff, one that uses only the most advanced hardware and software, and one that only employs in-house staff.
        </p>
      </div>
    </div>
  )
}

export default solution
